"use client";

import { usePathname } from "next/navigation";
import GlobalBreadcrumbs from "./breadcrumbs";
import React from "react";

export default function BreadcrumbsWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const hiddenRoutes = ["/auth/login", "/auth/register", "/user-profile"];

  /**
   * Route prefixes whose pages own the whole viewport and scroll their own
   * content rather than the document. The breadcrumb bar would add height above
   * such a page, making it overflow the viewport and putting a second scrollbar
   * on the document, so it's left out entirely.
   */
  const fullHeightRoutePrefixes = ["/company-details"];

  const isAuthRoute = pathname?.startsWith("/auth");
  const isFullHeightRoute = fullHeightRoutePrefixes.some((prefix) =>
    pathname?.startsWith(prefix)
  );
  const hideBreadcrumbs =
    isAuthRoute || isFullHeightRoute || hiddenRoutes.includes(pathname || "");

  return (
    <>
      {!hideBreadcrumbs && (
        <div className="breadcrumbs-wrapper">
          <GlobalBreadcrumbs />
        </div>
      )}
      {children}
    </>
  );
}
